import React from "react";
import { Check, X } from "lucide-react";

// Password rules mirrored from the backend (core.validate_password_strength).
export const PASSWORD_RULES = [
  { key: "length", label: "At least 8 characters", test: (p) => (p || "").length >= 8 },
  { key: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p || "") },
  { key: "lower", label: "One lowercase letter", test: (p) => /[a-z]/.test(p || "") },
  { key: "number", label: "One number", test: (p) => /\d/.test(p || "") },
];

export function isPasswordStrong(pw) {
  return PASSWORD_RULES.every((r) => r.test(pw));
}

// Inline checklist that lights up as the user types. Hidden until the field has input.
export function PasswordStrength({ password, testId = "password-strength" }) {
  if (!password) return null;
  return (
    <ul data-testid={testId} className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li
            key={r.key}
            data-testid={`${testId}-${r.key}`}
            className={`flex items-center gap-1.5 text-xs ${ok ? "text-[#2D6A4F]" : "text-[#8A9A86]"}`}
          >
            {ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
